module.exports = __webpack_public_path__ + "img/faro-gym.86065fff.jpg";